import React from "react";

const DotMenuStrongIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("path", {
  d: "M11 10C11 10.5523 10.5523 11 10 11C9.4477 11 9 10.5523 9 10C9 9.4477 9.4477 9 10 9C10.5523 9 11 9.4477 11 10Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7 10C7 10.5523 6.55228 11 6 11C5.44772 11 5 10.5523 5 10C5 9.4477 5.44772 9 6 9C6.55228 9 7 9.4477 7 10Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15 10C15 10.5523 14.5523 11 14 11C13.4477 11 13 10.5523 13 10C13 9.4477 13.4477 9 14 9C14.5523 9 15 9.4477 15 10Z",
  fill: "currentColor"
}));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(DotMenuStrongIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;